<template>
  <tr>
    <td>
      <strong v-text="report.attributes.name" />
    </td>
    <td>
      <div class="flex flex-wrap items-center">
        <ul class="tags max-w-xs ">
          <li
            v-for="column in columns"
            :key="column.uuid"
            class="tag-stack"
            v-text="column"
          />
        </ul>
      </div>
    </td>
    <td>
      <ul class="tags max-w-xs ">
        <li
          v-for="filter in filters"
          :key="filter.title"
          class="tag-stack"
          v-text="filterPreview(filter)"
        />
      </ul>
    </td>
    <td class="text-sm">
      <div class="whitespace-no-wrap">
        <button
          type="button"
          class="btn btn--sm "
          :disabled="reportIsRunning"
          :aria-disabled="reportIsRunning"
          @click="handleRun"
          v-text="'Run'"
        />
        <button
          v-can="'edit-membership-reports'"
          type="button"
          class="btn btn--border btn--sm ml-2"
          @click="handleEdit"
          v-text="'Edit'"
        />
        <button
          v-can="'edit-membership-reports'"
          type="button"
          class="btn btn--danger ml-2 btn--sm"
          @click="handleDelete"
          v-text="'Delete'"
        />
      </div>
    </td>
  </tr>
</template>

<script type="text/babel">
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'MembershipReportRow',
  props: {
    report: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      reportIsRunning: 'membershipIsMembershipReportRunning',
      availableColumns: 'membershipGetAvailableReportColumns',
    }),
    columns() {
      return this.report.attributes.configuration.columns
    },
    filters() {
      return this.report.attributes.configuration.filters
    },
  },
  methods: {
    ...mapActions({
      deleteReport: 'membershipDeleteMembershipReport',
    }),
    filterPreview(appliedFilter) {
      // @TODO: This should be improved to include more details about the filter schema.
      return appliedFilter.title
    },
    handleRun() {
      this.$emit('reportRun', this.report.uuid, this.report.attributes.name)
    },
    handleDelete() {
      this.deleteReport(this.report.uuid).then(() => {
        this.$emit('reportDeleted', this.report.uuid)
      })
    },
    handleEdit() {
      window.location = `/members/reports/${this.report.uuid}/edit`
    },
  },
}
</script>
